// extracted by mini-css-extract-plugin
export default {"AccountDetails":"AccountDetails_AccountDetails__t8IRJ"};